function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as PropTypes from 'prop-types';
import IntlMessage from '../commons/Intl';
import { Errors } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * 日付カスタムコンポーネント
 */

var CustomDateComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomDateComponent, _React$Component);

  var _super = _createSuper(CustomDateComponent);

  function CustomDateComponent() {
    _classCallCheck(this, CustomDateComponent);

    return _super.apply(this, arguments);
  }

  _createClass(CustomDateComponent, [{
    key: "render",

    /**
     * レンダラー
     */
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", null, !this.props.disabled && [/*#__PURE__*/React.createElement("div", {
        className: "form-group mb-1"
      }, /*#__PURE__*/React.createElement("input", {
        id: this.props.id,
        name: this.props.name,
        value: this.props.value,
        maxLength: 10,
        onChange: this.props.onChange,
        style: {
          display: "inline"
        },
        className: "col-8 input-validation-error form-control",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        "data-val-datetime": intl.format(Errors.InputDate),
        "data-val-datetime-format": "YYYY/M/D",
        placeholder: "YYYY/MM/DD",
        tabIndex: this.props.tabIndex,
        type: "text"
      }), /*#__PURE__*/React.createElement("a", {
        className: "calenderIcon margin-middle",
        tabIndex: -1,
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.props.onClick();
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "col-3 ml-1 margin-middle",
        width: "48",
        height: "50",
        src: "/assets/img/calender_icon.svg",
        alt: "CalendarIcon"
      }))), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": this.props.id,
        "data-valmsg-replace": "true"
      })], this.props.disabled && /*#__PURE__*/React.createElement("div", {
        className: "form-group mb-1"
      }, /*#__PURE__*/React.createElement("input", {
        id: this.props.id,
        name: this.props.name,
        value: this.props.value,
        maxLength: 10,
        disabled: true,
        style: {
          display: "inline"
        },
        className: "col-8 input-validation-error form-control",
        tabIndex: this.props.tabIndex,
        type: "text"
      }), /*#__PURE__*/React.createElement("img", {
        className: "col-3 ml-1 margin-middle",
        width: "48",
        height: "50",
        src: "/assets/img/calender_icon.svg",
        alt: "CalendarIcon",
        style: {
          marginLeft: ".55rem!important"
        }
      })));
    }
  }]);

  return CustomDateComponent;
}(React.Component);
/**
 * prop-types経由でreact-datepickerから流されてくる値
 */


export { CustomDateComponent as default };
CustomDateComponent.propTypes = {
  /**
   * オンクリックイベント
   */
  onClick: PropTypes.func,

  /**
   * 値
   */
  value: PropTypes.string
};